import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductById, toggleProductStatus } from "../../../slice/product/productSlice";

const BASE_URL = process.env.REACT_APP_API_URL;

const ViewProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [mainImage, setMainImage] = useState(0);

  const { currentProduct: p, loading, error } = useSelector((s) => s.product);

  useEffect(() => {
    dispatch(fetchProductById(id));
  }, [dispatch, id]);

  const imgSrc = (src) =>
    !src ? "/assets/images/placeholder.png"
    : src.startsWith("http") ? src
    : `${BASE_URL}/uploads/products/${src}`;

  const handleToggleStatus = () => dispatch(toggleProductStatus(p._id));

  if (loading || !p) {
    return (
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid">
        <div className="alert alert-danger mt-4">{error}</div>
      </div>
    );
  }

  const isCustom = p.customization?.length > 0;
  const mrp = p.mrp ?? 0;
  const sellingPrice = p.sellingPrice ?? 0;
  const discount = mrp > sellingPrice ? Math.round(((mrp - sellingPrice) / mrp) * 100) : 0;
  const galleryImages = p.images || [];

  return (
    <div className="container-fluid" style={{margin: "20px auto" }}>

      {/* Top bar */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <button
          onClick={() => navigate(-1)}
          style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "#6362e7", fontWeight: 600, background: "none", border: "none", cursor: "pointer", padding: 0 }}
        >
          ← Back to Products
        </button>
        <span style={{
          fontSize: 12, fontWeight: 700, padding: "6px 14px", borderRadius: 8,
          background: isCustom ? "#fdf4ff" : "#eff6ff",
          color: isCustom ? "#a21caf" : "#2563eb",
        }}>
          {isCustom ? "Custom Product" : "Normal Product"}
        </span>
      </div>

      <div className="card" style={{ borderRadius: 14, padding: 24 }}>

        {/* Image + basic info */}
        <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginBottom: 20 }}>
          <div style={{ width: 220, flexShrink: 0 }}>
            <div style={{ background: "#f8f7f4", borderRadius: 12, height: 220, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
              <img src={imgSrc(galleryImages[mainImage])} alt={p.productName} style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }} />
            </div>
            {galleryImages.length > 1 && (
              <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                {galleryImages.map((img, idx) => (
                  <img
                    key={idx}
                    src={imgSrc(img)}
                    onClick={() => setMainImage(idx)}
                    style={{
                      width: 44, height: 44, borderRadius: 8, objectFit: "cover", cursor: "pointer",
                      border: mainImage === idx ? "2px solid #6362e7" : "1px solid #e5e7eb",
                    }}
                    alt={`thumb-${idx}`}
                  />
                ))}
              </div>
            )}
          </div>

          {/* ── RIGHT: Info ── */}
<div style={{ flex: 1, minWidth: 260 }}>

  <div style={{ marginBottom: 10 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
      Product Name
    </div>
    <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{p.productName}</h2>
  </div>

  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>
      Category / Vendor 
    </div>
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      {p.category?.name && (
        <span style={{ fontSize: 12, background: "#f0f0ff", color: "#6362e7", padding: "4px 10px", borderRadius: 20 }}>
          {p.category.name}
        </span>
      )}
      {p.vendor_id?.vendorName && (
        <span style={{ fontSize: 12, background: "#f9fafb", color: "#888", padding: "4px 10px", borderRadius: 20 }}>
          {p.vendor_id.vendorName}
        </span>
      )}
    
    </div>
  </div>

  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
      Selling Price
    </div>
    <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
      <span style={{ fontSize: 24, fontWeight: 700 }}>${Number(sellingPrice).toLocaleString()}</span>
      {mrp > sellingPrice && (
        <span style={{ fontSize: 14, color: "#aaa", textDecoration: "line-through" }}>
          ${Number(mrp).toLocaleString()}
        </span>
      )}
      {discount > 0 && (
        <span style={{ fontSize: 12, fontWeight: 700, color: "#16a34a" }}>Save {discount}%</span>
      )}
    </div>
  </div>

  {!isCustom && (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
        Stock
      </div>
      <div style={{ fontSize: 13, fontWeight: 600, color: p.stock === 0 ? "#ef4444" : "#16a34a" }}>
        {p.stock === 0 ? "Out of Stock" : `${p.stock} in stock`}
      </div>
    </div>
  )}

  {p.description && (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
        Description
      </div>
      <p style={{ fontSize: 13, color: "#666", lineHeight: 1.6, margin: 0 }}>{p.description}</p>
    </div>
  )}

 
</div>
        </div>

        {/* Custom product options */}
        {isCustom && (
          <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#999", textTransform: "uppercase", marginBottom: 10 }}>
              Customization Options ({p.customization.length})
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {p.customization.map((c) => (
                <div key={c.custom_id} style={{ display: "flex", alignItems: "center", gap: 12, border: "1px solid #f0abfc", background: "#fdf4ff", borderRadius: 10, padding: "8px 14px" }}>
                  <img src={imgSrc(c.image)} alt="custom" style={{ width: 44, height: 44, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#a21caf" }}>{c.flowers.join(", ")}</div>
                    <div style={{ fontSize: 11, color: "#888" }}>{c.count} flower type{c.count > 1 ? "s" : ""}</div>
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>${c.price}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Simple details table */}
        <div style={{ borderTop: "1px solid #f0f0f0", marginTop: 16, paddingTop: 16 }}>
          {[
            { label: "Vendor", value: p.vendor_id?.vendorName ?? "—" },
            { label: "Vendor Mobile", value: p.vendor_id?.mobile ?? "—" },
            { label: "Category", value: p.category?.name ?? "—" },

            { label: "Best Selling", value: p.bestSellingProduct ? "Yes" : "No" },
            { label: "Popular", value: p.isPopular ? "Yes" : "No" },
            { label: "Created At", value: p.createdAt ? new Date(p.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—" },
            { label: "Updated At", value: p.updatedAt ? new Date(p.updatedAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—" },
          ].map(({ label, value }) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", fontSize: 13, borderBottom: "1px solid #f9f9f9" }}>
              <span style={{ color: "#888" }}>{label}</span>
              <span style={{ fontWeight: 600, color: "#333" }}>{value}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ViewProduct;